// Bridge to the native SleepTracker plugin (phone-on-bed accelerometer sleep
// estimator). No-op on web.
let SleepTracker = null
try {
  const { registerPlugin } = require('@capacitor/core')
  SleepTracker = registerPlugin('SleepTracker')
} catch (e) {}

export { SleepTracker }
